import { render, staticRenderFns } from "./add.vue?vue&type=template&id=f8b283a2&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b283a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8b283a2')) {
      api.createRecord('f8b283a2', component.options)
    } else {
      api.reload('f8b283a2', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=f8b283a2&scoped=true&", function () {
      api.rerender('f8b283a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/popularize/add.vue"
export default component.exports